import { render, staticRenderFns } from "./RandomChatView.vue?vue&type=template&id=203d2148&scoped=true&"
import script from "./RandomChatView.vue?vue&type=script&lang=js&"
export * from "./RandomChatView.vue?vue&type=script&lang=js&"
import style0 from "./RandomChatView.vue?vue&type=style&index=0&id=203d2148&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "203d2148",
  null
  
)

export default component.exports